module.exports = __webpack_public_path__ + "ef0386caf4a76ebff26e4bdc709c02d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C00001764.png
// module id = 1664
// module chunks = 0